function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'damson-blue': 'rgb(133, 76, 101)','black-stainless': 'rgb(13, 17, 21)','brushed-stainless-steel': 'rgb(207, 212, 217)','olive-tapenade': 'rgb(183, 120, 45)','black-truffle': 'rgb(43, 41, 38)','sea-salt': 'rgb(234, 234, 228)','black-stainless-steel': 'rgb(66, 65, 62)','obsidian-black': 'rgb(0, 0, 0)','obsidian-black-steel': 'rgb(148, 146, 146)','dune': 'rgb(198, 183, 180)','hario-blue': 'rgb(7, 80, 129)','turqoise': 'rgb(103, 158, 152)','juniper': 'rgb(77, 96, 83)','amber': 'rgb(243, 188, 80)','smoke': 'rgb(179, 183, 186)','charcoal': 'rgb(93, 93, 93)','natural': 'rgb(230, 228, 217)','kbgv-matte-silver-e2e2e2': '',};

    this.images = {'kbgv-midnight-blue': 'url("//espressocanada.com/cdn/shop/files/KBGV_Midnight_Blue_120x.webp?v=9873830300864937318")','kbgv-butter-yellow': 'url("//espressocanada.com/cdn/shop/files/KBGV_Butter_Yellow_120x.webp?v=10554423322263844850")','kbgv-matte-black': 'url("//espressocanada.com/cdn/shop/files/KBGV_Matte_Black_120x.webp?v=5262353475008192634")','kbgv-matte-silver': 'url("//espressocanada.com/cdn/shop/files/KBGV_Matte_Silver_120x.webp?v=10519639529243449514")','kbgv-off-white': 'url("//espressocanada.com/cdn/shop/files/KBGV_Off_White_120x.webp?v=5071183962543344037")','kbgv-sandstone': 'url("//espressocanada.com/cdn/shop/files/KBGV_Sandstone_120x.webp?v=16052985288035422427")','kbgv-pistachio': 'url("//espressocanada.com/cdn/shop/files/KBGV_Pistachio_120x.webp?v=5058725879984617542")','kbgv-juniper': 'url("//espressocanada.com/cdn/shop/files/KGBV_Juniper_120x.webp?v=3979425372763345513")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
